// src/app/topbar/topbar.component.ts
// CHANGES: Added navigateToDashboard() method + dashboard pageTitle mapping
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NotificationService } from '../notifications/notification.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit, OnDestroy {
  username: any;
  useremail: any;
  userRole: any;
  pageTitle = 'Dashboard';

  private notifSub!: Subscription;
  showNotifications: boolean = false;

  get unreadCount(): number {
    return this.notifService.unreadCount;
  }

  constructor(
    private router: Router,
    public notifService: NotificationService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updatePageTitle();
      this.showNotifications = false;
    });
    this.updatePageTitle();
  }

  ngOnInit(): void {
    this.useremail = localStorage.getItem('user_email');
    this.username  = localStorage.getItem('name');
    this.userRole  = localStorage.getItem('groups');
    this.notifService.loadNotifications();
  }

  ngOnDestroy(): void {
    this.notifSub?.unsubscribe();
  }

  toggleNotifications(event: Event): void {
    event.stopPropagation();
    this.router.navigate(['/notifications']);
  }

  // ── NEW: navigate to dashboard from topbar icon ──────────
  navigateToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  updatePageTitle(): void {
    const path = this.router.url;

    // ── NEW: Dashboard route ─────────────────────────────────
    if (path === '/dashboard' || path.startsWith('/dashboard')) {
      this.pageTitle = 'Dashboard';
    }
    else if (path.includes('queries') || path.includes('viewdoc') || path.includes('download-details') || path.includes('review-details')) {
      this.pageTitle = 'Inquiries';
    }
    else if (path.includes('matter')) {
      this.pageTitle = 'Matters';
    }
    else if (path.includes('groups/create-group') || path.includes('groups/view-group') || path.includes('groups/view-member') || path.includes('groups/create-member')) {
      this.pageTitle = 'Members';
    }
    else if (path.includes('relationship')) {
      this.pageTitle = 'Relationships';
    }
    else if (path.includes('document/upload/firm') || path.includes('document/view/firm') || path.includes('document/view/delete')) {
      this.pageTitle = 'Documents';
    }
    else if (path.includes('admin/marketing-offers/approval')) {
      this.pageTitle = 'Approval';
    }
    else if (path.includes('admin/marketing-offers/create')) {
      this.pageTitle = 'Create Offer';
    }
    else if (path.match('admin/marketing-offers/edit')) {
      this.pageTitle = 'Edit Offer';
    }
    else if (path.match('admin/marketing-offers/view')) {
      this.pageTitle = 'View Offer';
    }
    else if (path.includes('admin/marketing-offers')) {
      this.pageTitle = 'Marketing Offers';
    }
    else if (path.includes('admin/members')) {
      this.pageTitle = 'Add Members';
    }
    else if (path.includes('admin/lexiz-lawyers')) {
      this.pageTitle = 'LexiZ Lawyers';
    }
    else if (path.includes('admin/lawyer-leads')) {
      this.pageTitle = 'LexiZ Lawyers';
    }
    else if (path.includes('admin/lexiz-clients')) {
      this.pageTitle = 'LexiZ Clients';
    }
    else if (path.includes('admin/client-leads')) {
      this.pageTitle = 'LexiZ Clients';
    }
    else if (path.includes('admin/lexiz-corporate')) {
      this.pageTitle = 'LexiZ Corporate';
    }
    else if (path.includes('admin/other-products')) {
      this.pageTitle = 'Other Products';
    }
    else if (path.includes('notifications')) {
      this.pageTitle = 'Notifications';
    }
    else if (path.includes('audit-trails')) {
      this.pageTitle = 'Audit Trails';
    }
    else if (path.includes('admin/contact-us')) {
      this.pageTitle = 'Contact Us';
    }
    else if (path.includes('admin/appointments')) {
      this.pageTitle = 'Appointments';
    }
    else {
      this.pageTitle = 'Dashboard';
    }
  }

  getPageTitle(): string {
    return this.pageTitle;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}